import {set, update, isNull, get, unset, pipe} from 'lodash/fp';
import {
  CONTENT_FETCH_REQUEST,
  CONTENT_FETCH_SUCCESS,
  CONTENT_FETCH_FAILURE,
  CONTENT_INFO_FETCH_SUCCESS,
  CONTENT_INFO_FETCH_FAILURE
} from '../../actions/api/contents';
import {PROGRESSION_FETCH_BESTOF_SUCCESS} from '../../actions/api/progressions';

const dataContentReducer = (state = {}, action) => {
  switch (action.type) {
    case CONTENT_FETCH_REQUEST: {
      const {meta} = action;
      const {type, ref} = meta;
      return update([type, 'entities', ref], content => content || null, state);
    }
    case CONTENT_FETCH_SUCCESS: {
      const {payload, meta} = action;
      const {type, ref} = meta;
      return pipe(set([type, 'isFailure'], false), set([type, 'entities', ref], payload))(state);
    }
    case CONTENT_FETCH_FAILURE: {
      const {meta} = action;
      const {type, ref} = meta;
      const _state = set([type, 'isFailure'], true, state);
      if (pipe(get([type, 'entities', ref]), isNull)(_state))
        return unset([type, 'entities', ref], _state);
      return _state;
    }
    case CONTENT_INFO_FETCH_SUCCESS: {
      const {payload: info, meta} = action;
      const {type, ref} = meta;
      return pipe(
        set([type, 'isFailure'], false),
        set([type, 'entities', ref, 'info'], info)
      )(state);
    }
    case CONTENT_INFO_FETCH_FAILURE: {
      const {type} = action.meta;
      return set([type, 'isFailure'], true, state);
    }
    case PROGRESSION_FETCH_BESTOF_SUCCESS: {
      const {payload, meta} = action;
      const {type, ref} = meta;
      const {stars} = payload;
      return pipe(
        set([type, 'isFailure'], false),
        set([type, 'entities', ref, 'bestScore'], stars)
      )(state);
    }
    default:
      return state;
  }
};

export default dataContentReducer;
